import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'a-unit-legend',
    templateUrl: './a-unit-legend.component.html',
    styleUrls: ['./a-unit-legend.component.scss'],
    standalone: false
})
export class AUnitLegendComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
